package xim.poc.game.configuration.v0.tactics

import xim.poc.game.ActorState
import xim.poc.game.GameEngine
import xim.poc.game.StatusEffect
import xim.poc.game.StatusEffectState
import xim.poc.game.configuration.v0.CombatBonusAggregator
import xim.poc.game.event.ActorEffectTick
import xim.poc.game.event.ActorEffectTickResult
import xim.poc.gl.ByteColor
import xim.poc.ui.ChatLog
import xim.poc.ui.DamageTextManager
import xim.poc.ui.ShiftJis
import kotlin.math.abs

object TacticsStatusHelper {

    fun shouldCountDown(statusEffectState: StatusEffectState): Boolean {
        return getStatusHandler(statusEffectState)
    }

    fun processStatusEffects(actorState: ActorState) {
        val bonuses = CombatBonusAggregator[actorState]

        // Prevent dying to HP ticks
        val hpTick = if (bonuses.regen < 0 && abs(bonuses.regen) >= actorState.getHp()) {
            -(actorState.getHp() - 1)
        } else {
            bonuses.regen
        }

        if (hpTick == 0) { return }

        val (message, color) = if (hpTick > 0) {
            "+${hpTick} HP." to ByteColor(0x20, 0x50, 0x80, 0x80)
        } else {
            "$hpTick HP." to ByteColor(0x80, 0x40, 0x30, 0x80)
        }

        DamageTextManager.append(actorState, "Tick: $message", color)
        ChatLog("${ShiftJis.colorInfo}[Status Tick]${ShiftJis.colorClear} ${actorState.name} $message")

        val result = ActorEffectTickResult(hpDelta = hpTick, mpDelta = 0, tpDelta = 0)
        GameEngine.submitEvent(ActorEffectTick(actorState.id, result))
    }

    private fun getStatusHandler(statusEffectState: StatusEffectState): Boolean {
        return when (statusEffectState.statusEffect) {
            StatusEffect.Stoneskin -> false
            StatusEffect.Blink -> false
            StatusEffect.Boost -> false
            StatusEffect.Spontaneity -> false
            StatusEffect.UnbridledLearning -> false
            else -> true
        }
    }

}